// FORMIK
import { Field } from "formik";

// MUI
import Autocomplete from "@mui/material/Autocomplete";
import FormHelperText from "@mui/material/FormHelperText";
import TextField from "@mui/material/TextField";

export default function InputAutocomplete({
	id = null,
	name,
	label,
	sx,
	disabled = false,
	auto_focus = false,
	size = "medium",
	multiple = true,
	options,
}) {
	return (
		<Field name={name} autocomplete="off" autoComplete="off">
			{({ field, meta, form }) => {
				const handleUpdate = (_event, values) => form.setFieldValue(name, values);

				return (
					<>
						<Autocomplete
							id={id}
							{...field}
							defaultValue={field.value}
							multiple={multiple}
							options={options}
							size={size}
							autoHighlight={auto_focus}
							getOptionLabel={(option) => option.name}
							isOptionEqualToValue={(option, value) => option.value === value.value}
							onChange={handleUpdate}
							disabled={disabled}
							filterSelectedOptions
							sx={{ ...sx }}
							renderInput={(params) => <TextField {...params} label={label} />}
						/>
						<FormHelperText sx={{ color: "error.main", px: 2 }}>
							{meta.error && meta.touched ? meta.error : null}
						</FormHelperText>
					</>
				);
			}}
		</Field>
	);
}
